"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _components = require("../../components");
var _utilities = require("@indigenux/indi/utilities");
var _notistack = require("notistack");
var _jsxRuntime = require("react/jsx-runtime");
const Login = _ref => {
  let {
    logo,
    logoAlt
  } = _ref;
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const handleMessage = message => {
    enqueueSnackbar(message);
  };
  const loginTabID = 'login';
  const registerTabID = 'register';
  const [activeTab, setActiveTab] = (0, _react.useState)('login');
  const handleClick = evt => {
    setActiveTab($(evt.target).attr('id'));
  };
  const [username, setUserName] = (0, _react.useState)();
  const [password, setPassword] = (0, _react.useState)();
  const handleSubmit = async e => {
    e.preventDefault();
    _utilities.securityUtil.login({
      username,
      password
    }, "/", err => {
      /* Put in toast message */
      handleMessage(err.error);
    });
    if (_utilities.securityUtil.isLoggedIn()) {
      handleMessage("SUCCESS!");
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("main", {
      role: "main",
      className: "main",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
        className: "body-sign",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "center-sign",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
            href: "/",
            className: "logo float-start",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: logo,
              height: "70",
              alt: logoAlt
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "panel card-sign",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "card-title-sign mt-3 text-end",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Heading, {
                level: "h2",
                cssName: "title text-uppercase font-weight-bold m-0",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                  className: "bx bx-user-circle me-1 text-6 position-relative top-5"
                }), " Sign In"]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "card-body",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "form-group mb-3",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
                    children: "Username"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "input-group",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                      name: "username",
                      type: "text",
                      className: "form-control form-control-lg",
                      onChange: e => setUserName(e.target.value)
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      className: "input-group-text",
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                        className: "bx bx-user text-4"
                      })
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "form-group mb-3",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "clearfix",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
                      className: "float-left",
                      children: "Password"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
                      href: "/reset",
                      className: "float-end",
                      children: "Lost Password?"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "input-group",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                      name: "pwd",
                      type: "password",
                      className: "form-control form-control-lg",
                      onChange: e => setPassword(e.target.value)
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      className: "input-group-text",
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                        className: "bx bx-lock text-4"
                      })
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "row",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "col-sm-8",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Checkbox, {
                      id: "RememberMe",
                      label: "Remember Me"
                    })
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "col-sm-4 text-end",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                      type: "submit",
                      className: "btn btn-primary mt-2",
                      children: "Sign in"
                    })
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "mt-3 mb-3 line-thru text-center text-uppercase",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    children: "or"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "mb-1 text-center",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Link, {
                    className: "btn btn-facebook mb-3 ms-1 me-1",
                    href: "#",
                    children: ["Connect with ", /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                      className: "fab fa-facebook-f"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Link, {
                    className: "btn btn-twitter mb-3 ms-1 me-1",
                    href: "#",
                    children: ["Connect with ", /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                      className: "fab fa-twitter"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                  className: "text-center",
                  children: ["Trouble accessing your account? ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
                    href: "#",
                    children: "Get help!"
                  })]
                })]
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            className: "text-center text-muted mt-3 mb-3",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IndiText, {
              uxCSSclassName: "text-color-primary"
            }), " \xA9 2023. All Rights Reserved"]
          })]
        })
      })
    })
  });
};
var _default = exports.default = Login;